import RangeDatepicker from "./RangeDatepicker";

export default RangeDatepicker;
